import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { NofshonReservationTimerService } from '../nofshon-reservation-timer.service';
import { timer, Subscription, Observable } from 'rxjs';
import { ConfigService } from 'app/shared/config.service';


@Component({
  selector: 'nofshon-reservation-timer',
  templateUrl: './nofshon-reservation-timer.component.html',
  styleUrls: ['./nofshon-reservation-timer.component.css']
})
export class NofshonReservationTimerComponent implements OnInit, OnDestroy {

  showTimer: boolean = false;
  remainedTime: string = "";
  isTimeout: boolean = false;
  lessThanMinuteRemained: boolean = false;
  timerMaxMinutes: number;

  private _showTimerSubscription: Subscription;
  private _currentTimerSubscription: Subscription;
  private _timeoutSubscription: Subscription;

  

  constructor(private _nofshonReservationTimerService : NofshonReservationTimerService, private _configService: ConfigService)
  {
    const timerMinutesInConfig = this._configService.getConfigPropertyByKey("nofshonReservationTimerMinutes");
    if(timerMinutesInConfig && (typeof timerMinutesInConfig === "number" || !isNaN(+timerMinutesInConfig)))
    {
      this.timerMaxMinutes = timerMinutesInConfig;
    }
  }

  ngOnInit() {
    this._showTimerSubscription = this._nofshonReservationTimerService.showTimer$.subscribe((showTimer: boolean) => this.showTimer = showTimer );
    this._currentTimerSubscription = this._nofshonReservationTimerService.currentTimer$.subscribe((time: string) => this.remainedTime = time );
    this._timeoutSubscription = this._nofshonReservationTimerService.timerTimeout$.subscribe((isTimeout: boolean) => this.isTimeout = isTimeout );
  }

  private _unsubscribeAll(): void
  {
    if(this._showTimerSubscription)
    {
      this._showTimerSubscription.unsubscribe();
    }

    if(this._currentTimerSubscription)
    {
      this._currentTimerSubscription.unsubscribe();
    }

    if(this._timeoutSubscription)
    {
      this._timeoutSubscription.unsubscribe();
    }
  }

  ngOnDestroy(): void 
  {
    this._unsubscribeAll();
  }
}
